module.exports = __webpack_public_path__ + "img/manutenzione-impianto.2d1f73af.jpg";